"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCharges = void 0;
var date_fns_1 = require("date-fns");
var core_1 = require("../../../shared/core");
var date_1 = require("../utils/date");
function upgradeDetails(upgrade) {
    var description = upgrade.description, grossCharge = upgrade.grossCharge;
    var coversOneMonth = firstOfMonthToFirstOfNextMonth(upgrade);
    return {
        title: description,
        amount: (0, core_1.major2DP)((0, core_1.majorToMinor)(grossCharge.pounds)),
        context: upgradeContext(upgrade, coversOneMonth),
        initialAmount: initialAmountString(upgrade, coversOneMonth),
    };
}
function firstOfMonthToFirstOfNextMonth(_a) {
    var start = _a.startDate, end = _a.endDate;
    var startDate = new Date(start);
    var endDate = new Date(end);
    var nextMonth = (0, date_fns_1.addMonths)(startDate, 1);
    return (startDate.getDate() === 1 &&
        endDate.getDate() === 1 &&
        (0, date_fns_1.isSameMonth)(nextMonth, endDate));
}
function initialAmountString(_a, coversOneMonth) {
    var grossCharge = _a.grossCharge, initialGrossCharge = _a.initialGrossCharge;
    if (grossCharge.pounds === initialGrossCharge.pounds) {
        return undefined;
    }
    if (!coversOneMonth) {
        // For a "part payment" the gross will always be different from the initialGross
        return undefined;
    }
    return (0, core_1.major2DP)((0, core_1.majorToMinor)(initialGrossCharge.pounds));
}
function upgradeContext(_a, coversOneMonth) {
    var startDate = _a.startDate, endDate = _a.endDate, taxRate = _a.taxRate;
    if (coversOneMonth) {
        return taxRate === null ? undefined : "(includes ".concat(taxRate, "% VAT)");
    }
    var dateRange = formatRange(startDate, endDate);
    return taxRate === null
        ? dateRange
        : "".concat(dateRange, ", including ").concat(taxRate, "% VAT");
}
function formatRange(startDate, endDate) {
    if (startDate === endDate) {
        return (0, date_1.formatDate)(startDate);
    }
    return "".concat((0, date_1.formatDate)(startDate, 'do'), "-").concat((0, date_1.formatDate)(endDate));
}
var MigratedBalanceDescription = 'Migrated Balance';
var genericTransactionCharge = function (_a) {
    var description = _a.description, netCredit = _a.netCredit;
    return ({
        label: description,
        value: -Number(netCredit.pounds),
    });
};
var generateTransactionsCharges = function (transactions, _a) {
    var vatCharge = _a.vatCharge, netCharge = _a.netCharge;
    var charges = [];
    var migratedBalanceRemoved = transactions.filter(function (_a) {
        var description = _a.description;
        return description !== MigratedBalanceDescription;
    });
    var taxable = migratedBalanceRemoved
        .filter(function (_a) {
        var taxRate = _a.taxRate;
        return taxRate !== null;
    })
        .map(genericTransactionCharge);
    var nonTaxable = migratedBalanceRemoved
        .filter(function (_a) {
        var taxRate = _a.taxRate;
        return taxRate === null;
    })
        .map(genericTransactionCharge);
    charges.push.apply(charges, __spreadArray([], __read(taxable), false));
    charges.push({
        // TODO: rollout copy tooling: CPCE-1846
        label: 'VAT',
        value: Number(vatCharge.pounds),
        // TODO: rollout copy tooling: CPCE-1846
        context: "5% of ".concat((0, core_1.major2DP)((0, core_1.majorToMinor)(netCharge.pounds))),
    });
    charges.push.apply(charges, __spreadArray([], __read(nonTaxable), false));
    return charges;
};
/**
 * Generates rows with correctly formatted labels, values, and contexts based on
 * the transactions provided. Adapted from similar function:
 * ../charges-in-detail/TransactionSection.tsx
 **/
var generateCharges = function (upgrades, transactions, totalCharge) {
    var charges = [];
    var upgradeCharges = upgrades.map(function (upgrade) {
        var _a = upgradeDetails(upgrade), title = _a.title, context = _a.context;
        return {
            label: title,
            context: context,
            value: Number(upgrade.grossCharge.pounds),
        };
    });
    var transactionCharges = generateTransactionsCharges(transactions, totalCharge);
    charges.push.apply(charges, __spreadArray(__spreadArray([], __read(transactionCharges), false), __read(upgradeCharges), false));
    return charges;
};
exports.generateCharges = generateCharges;
